import { Pagination as ApiPagination } from 'src/api/generated/touring/types';
import { PaginationType } from './types';

export const mapPaginationType = (
  apiPagination: ApiPagination | undefined
): PaginationType => {
  return {
    page: apiPagination?.page ?? 0,
    pageSize: apiPagination?.pageSize ?? 0,
    pageCount: apiPagination?.pageCount ?? 0,
    total: apiPagination?.total ?? 0,
  };
};
